import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import Navbar from "./partials/Navbar";
import FooterDark from './partials/FooterDark';

import { InlineWidget } from "react-calendly";

export default function Scheduler (props) {


    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])


    const[getStartedButton, setGetStartedButton]=useState(false)
 
    let backgroundStyleWhite = {
        background: "#FFF",
        padding: '0 0 0 0',
    }

    let buttonStyleTrue = {
        borderRadius: '5px',
        margin: '5px auto',
        padding: '10px 20px',
        border: '1px solid #007bff',
        color: '#FFF',
        background: '#007bff',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        cursor: 'pointer',
    }
    
    let buyButtonStyleTrue = {
        border: '1px solid #007bff',
        color: '#FFF',
        borderRadius: '10px',
        background: "#007bff",
        margin: '10px 5px 0px 5px',
        padding: '10px 20px',
        cursor: 'pointer',
        width: '340px',
        textAlign: 'center',
        textDecoration: 'none',
        // position: 'fixed',
        // zIndex: '3',
      }
      

    let pStyle = {
        margin: '0 0 4px 0',
        fontSize: "20px",
    }


    return(
        <div style={backgroundStyleWhite}>
            <Navbar/>
            <div
                style={{
                    width: "100%",
                    maxWidth: "800px",
                    margin: "50px auto",
                    textAlign: "center",
                }}
                >
 
                <p>THANK YOU FOR YOUR PURCHASE!</p>
                <p>Next, schedule a time for your clinic intake session using the calendar below</p>
                <p>You can close this browser tab when you are done</p>
                <div
                    style={{
                    marginTop: "40px",
                    }}
                >
                    <div style={{ height: "700px" }}>
                    <InlineWidget url="https://calendly.com/cataractpreop/30min?hide_event_type_details=1&hide_landing_page_details=1" />
                    </div>
                </div>
            </div>
            

            <FooterDark/>
        </div>
    )
} 

